import MarketplacePage from './MarketplacePage'

export default MarketplacePage
